import * as yup from 'yup';
import dayjs from 'dayjs';

export const CaptainConf = {
    schema: {
      birthdate: yup
			.date()
			.nullable()
			.transform((value) => {
				if (value && dayjs(value).isValid()) {
					return value;
				}
				return null;
			}).required('Birthdate is required'),
    },
    defaultValues: {
        birthdate: null,
    },
    fields: [
        {
        	id: 'birthdate',
        	name: 'birthdate',
        	type: 'date',
			label: 'Birthdate',
        	required: true,
        	xs: 12,
        	sm: 6,
        },
    ],
};
